export default class ENTRY_MANAGEMENT_STATUS {
  static CODE = {
    APPLY_READY     : "APPLY_READY",
    APPLY_FAILED    : "APPLY_FAILED",
    APPLIED         : "APPLIED",
    GENERATE_READY  : "GENERATE_READY",
    GENERATE_FAILED : "GENERATE_FAILED",
    GENERATED       : "GENERATED",
  };

  static exists(code) {
    return Object.values(ENTRY_MANAGEMENT_STATUS.CODE).includes(code);
  }

  static name(status) {
    switch (status) {
      case ENTRY_MANAGEMENT_STATUS.CODE.APPLY_READY:
        return '申請前';
      case ENTRY_MANAGEMENT_STATUS.CODE.APPLY_FAILED:
        return '申請失敗';
      case ENTRY_MANAGEMENT_STATUS.CODE.APPLIED:
        return '申請完了';
      case ENTRY_MANAGEMENT_STATUS.CODE.GENERATE_READY:
        return '電子証明書発行前';
      case ENTRY_MANAGEMENT_STATUS.CODE.GENERATE_FAILED:
        return '電子証明書発行失敗';
      case ENTRY_MANAGEMENT_STATUS.CODE.GENERATED:
        return '電子証明書発行完了';
      default:
        return '';
    }
  };

}